"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLanguageText = exports.StyledLanguageSelector = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledLanguageSelector = (0, styled_components_1.default)(general_1.Flexbox) `
  padding: ${theme_1.spacings.s6} ${theme_1.spacings.s8} 0;
`;
exports.StyledLanguageText = (0, styled_components_1.default)(general_1.Typography) `
  ${({ index = '', selectedLanguage }) => {
    const isActive = index === selectedLanguage;
    return (0, styled_components_1.css) `
      color: ${isActive && theme_1.primary.light};
      font-weight: ${isActive ? 600 : 500};
      padding: 10px;
    `;
}}
`;
//# sourceMappingURL=styles.js.map